const baseUrl = 'https://journary.herokuapp.com'// or http://localhost:8080 if you're on local host
export default baseUrl